import { render, staticRenderFns } from "./PredixFavoriteAlloyDialog.vue?vue&type=template&id=38780ff0&scoped=true"
import script from "./PredixFavoriteAlloyDialog.vue?vue&type=script&lang=js"
export * from "./PredixFavoriteAlloyDialog.vue?vue&type=script&lang=js"
import style0 from "./PredixFavoriteAlloyDialog.vue?vue&type=style&index=0&id=38780ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38780ff0",
  null
  
)

export default component.exports